import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, ToastController } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { WordpressService } from './services/publish-targets/wordpress.service';
import { DataService } from './services/data.service';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TopbarModule } from './components/topbar/topbar.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { AuthInterceptor } from './services/guard/auth.interceptor';
import { AuthService } from './services/guard/auth.service';
import { AuthServiceFactory } from './services/guard/auth.service.factory';
import { EditSocialCardComponent } from './components/edit-social-card/edit-social-card.component';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { ErrorBannerComponent } from './components/error-banner/error-banner.component';
import { CreateSupportTicketModalComponent } from './modals/create-support-ticket-modal/create-support-ticket-modal.component';
import { EditFacebookModalComponent } from './modals/edit-facebook-modal/edit-facebook-modal.component';
import { ImageSelectionModule } from './modals/image-selection-modal/image-selection-modal.module';
import { PostTypeHelperModalComponent } from './modals/post-type-helper-modal/post-type-helper-modal.component';
import { SuggestionModule } from './modals/suggestion-modal/suggestion-modal.module';
import { PublishTargetSummariesModule } from './modals/publish-target-summaries/publish-target-summaries.module';

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    NavMenuComponent,
    PostTypeHelperModalComponent,
    ErrorBannerComponent,
    CreateSupportTicketModalComponent,
    EditFacebookModalComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    TopbarModule,
    QuillModule.forRoot(),
    SuggestionModule,
    PublishTargetSummariesModule,
    ImageSelectionModule,
    IonicStorageModule.forRoot({
      name: 'socialdash',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
    }),
    // standalone component import so its selector and inputs are available to templates
    EditSocialCardComponent,
  ],
  exports: [
    TopbarModule,
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    AuthService,
    AuthServiceFactory,
    DataService,
    WordpressService,
    ToastController,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
  ],
  bootstrap: [
    AppComponent
  ],
})
export class AppModule { }
